/**
 * Authentication Service
 *
 * Handles all authentication-related API calls to the backend.
 * Provides methods for login, logout, signup, and password reset functionality.
 *
 * This is a backward compatibility layer that exports all authentication modules.
 *
 * Backend API endpoints:
 * - POST /api/login/ - User login
 * - POST /api/login/token - OAuth2 token endpoint
 * - POST /api/logout/ - User logout
 * - POST /api/signup/send-otp - Send OTP for registration
 * - POST /api/signup/verify-otp - Verify OTP and create account
 * - POST /api/password-reset/request - Request password reset
 * - POST /api/password-reset/confirm - Confirm password reset
 */

import { authMethods } from "./core/authMethods.js";
import { authValidation as validation } from "./core/authValidation.js";
import { authRedirect as redirect } from "./core/authRedirect.js";

/**
 * Authentication API Service
 * Re-exported from core/authMethods.js
 */
export const authService = authMethods;

/**
 * Form validation utilities
 * Re-exported from core/authValidation.js
 */
export const authValidation = validation;

/**
 * Authentication redirect utilities
 * Re-exported from core/authRedirect.js
 */
export const authRedirect = redirect;

/**
 * Default export for backward compatibility
 */
export default authService;
